import store from "@/store";

export const checkRole = roles => {
  if (typeof roles === "string") {
    roles = [roles];
  }
  let ret = false;
  roles.forEach(papel => {
    ret = ret || store.getters.userRoles.includes(papel);
  });
  return ret;
};
export const cloneObject = object => {
  return JSON.parse(JSON.stringify(object));
};

export const GetCardImagePath = name => {
  let imageContainer = "";

  if(!name || name.length <= 0) 
    return imageContainer;

  switch (name.trim().toLowerCase()) {
    case "mastercard":
      imageContainer = "resources/images/card/mastercard.png";
      break;
    case "maestro":
    case "mastercard maestro": 
      imageContainer = "resources/images/card/maestro.png";
      break;
    case "visa":
    case "visa electron":
      imageContainer = "resources/images/card/visa.png";
      break;
    case "diners":
      imageContainer = "resources/images/card/diners.png";
      break;
    case "elo":
    case "elo debito":
    case "elo credito":
      imageContainer = "./resources/images/card/elo.png";
      break;
    case "american express":
      imageContainer = "./resources/images/card/amex.png";
      break;  
    case "hipercard" :
      imageContainer = "./resources/images/card/hipercard.png";
      break;  

      case "pix" :
      imageContainer = "./resources/images/card/pix.png";
      break;  
      
    default:
      imageContainer = "./resources/images/card/nocard.png";
      break;
  }
  return imageContainer;
};

export const FormatCurrency = value => {
  let auxValue;
  if (!value) {
    return "R$ 0,00";
  }
  if (Array.isArray(value)) {
    // eslint-disable-next-line prefer-destructuring
    auxValue = value[0];
  } else {
    auxValue = value;
  }

  return `R$ ${auxValue.toLocaleString("pt-BR", {
    // Ajustando casas decimais
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })}`;
};
